var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Iconly/Bulk/Activity",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.5 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.828 25H6.682a6.768 6.768 0 01-4.92-1.764A6.752 6.752 0 010 18.326V9.195a6.785 6.785 0 011.763-4.92A6.75 6.75 0 016.682 2.5h9.958a4.887 4.887 0 00-.088.922 5.036 5.036 0 005.034 5.026 5.177 5.177 0 00.912-.088v9.965a6.757 6.757 0 01-1.761 4.909A6.752 6.752 0 0115.828 25zM9.027 11.349a.94.94 0 00-.123.008.926.926 0 00-.617.362l-3.693 4.764a.911.911 0 00-.2.572.924.924 0 001.7.538l3.088-4 3.429 2.69a.933.933 0 00.58.2.926.926 0 00.739-.37l3.572-4.609v-.015a.937.937 0 00-.176-1.306.913.913 0 00-1.3.187l-3.012 3.874-3.414-2.7a.927.927 0 00-.573-.195z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.125,
    cy: 3.125,
    r: 3.125,
    transform: "translate(18.75)",
    opacity: 0.4
  }))));
}

export default SvgActivity;